import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { InputSuffix } from "#components/atoms/InputSuffix/InputSuffix";
import { getSurfaceTreatmentPriceSuffix } from "#modules/company/view/surfaceTreatmentLabels";
import { centsToEuro, euroToCents, parseInputNumberValue } from "#shared/helpers/prices";
import { SurfaceTreatmentMethodType } from "shared";

const formatEuroInput = (cents: number | null): string =>
  cents === null ? "" : String(centsToEuro(cents)).replace(".", ",");

type ProcessStepPriceCellProps = {
  value: number | null;
  method: SurfaceTreatmentMethodType;
  showValidationErrors: boolean;
  onUpdate: (value: number) => void;
};

export const ProcessStepPriceCell = ({
  value,
  method,
  showValidationErrors,
  onUpdate,
}: ProcessStepPriceCellProps) => {
  const { t } = useTranslation();
  const [inputValue, setInputValue] = useState(formatEuroInput(value));
  const suffix = getSurfaceTreatmentPriceSuffix(t, method);

  useEffect(() => setInputValue(formatEuroInput(value)), [value]);

  const handleBlur = () => {
    const euros = parseInputNumberValue(inputValue);
    if (Number.isNaN(euros) || euros < 0) {
      setInputValue(formatEuroInput(value));
      return;
    }

    const cents = euroToCents(euros);
    if (cents !== value) {
      onUpdate(cents);
    }
  };

  return (
    <InputSuffix
      value={inputValue}
      onChange={setInputValue}
      onBlur={handleBlur}
      suffix={suffix}
      error={showValidationErrors && value === null}
      aria-label={t("onboardingV2.processStepConfiguration.columns.price")}
    />
  );
};
